<template>
  <gj-modal
      size="1300_auto"
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
  >
    <template #header>
      <div>
        订单详情
        <template v-for="(item, index) in saleOrderStatus">
          <template v-if="item.id === data.orderStatus">
            <gj-tag type="dark" :key="index" style="margin-left: 12px" :color="item">
              {{item.text}}
            </gj-tag>
          </template>
        </template>
        <template v-if="data.fulfillmentChannel === 'AFN'">
          <gj-tag type="dark" :color="tagColors.blueDark">
            FBA
          </gj-tag>
        </template>
        <template v-if="data.fulfillmentChannel === 'MFN'">
          <gj-tag type="dark" :color="tagColors.greenDark">
            FBM
          </gj-tag>
        </template>
        <template v-if="replacementOrder">
          <gj-tag type="dark" :color="tagColors.red">
            换货
          </gj-tag>
        </template>
        <template v-if="data.requestReviewStatus === 'Success'">
          <gj-tag type="dark" :color="tagColors.violetTwoDark">
            Request a Review
          </gj-tag>
        </template>
        <template v-if="data.vineOrder">
          <gj-tag type="dark" :color="tagColors.yellowDark" class="gj-mb5">
            VINE
          </gj-tag>
        </template>
      </div>
    </template>
    <template #content>
      <div style="font-size: 12px" v-loading="reloadLoading">
        <gj-area-title>订单基本信息</gj-area-title>
        <el-row class="gj-mb10">
          <el-col :span="8">
            <span class="detail-label">店铺/国家</span>
            <span class="detail-value">{{data.marketName}}</span>
          </el-col>
          <el-col :span="8">
            <span class="detail-label">订单编号</span>
            <span class="detail-value">{{data.orderId}}</span>
          </el-col>
          <el-col :span="8">
            <span class="detail-label">买家订单编号</span>
            <span class="detail-value">{{data.sellerOrderId}}</span>
          </el-col>
        </el-row>

        <el-row class="gj-mb10">
          <el-col :span="8">
            <span class="detail-label">订购时间</span>
            <span class="detail-value">{{data.purchaseDate}}</span>
          </el-col>
          <el-col :span="8">
            <span class="detail-label">订单总金额</span>
            <span class="detail-value">{{data.currencySymbol}}{{data.orderTotal}}</span>
          </el-col>
          <el-col :span="8">
            <span class="detail-label">买家姓名</span>
            <span class="detail-value">{{ data.buyerName || "亚马逊政策要求，暂停显示"}}</span>
          </el-col>
        </el-row>

        <el-row class="gj-mb10">
          <el-col :span="8">
            <span class="detail-label">买家邮箱</span>
            <span class="detail-value">{{data.buyerEmail || '-'}}</span>
          </el-col>
          <el-col :span="8" style="display: flex; align-items: center;">
            <span class="detail-label">卖家备注</span>
            <span class="detail-value">
              <div style="display: inline-block">
               <div :hidden="!memoFlag" style="cursor: pointer"
                    @click="memoFlag = false">
                <span
                    :class="[isNotBlank(data.memo) ? '' : 'detail-memo-color']">
                  {{isNotBlank(data.memo) ? data.memo : '还没有任何备注'}}</span>
                <i class="el-icon-edit" style="margin-left: 10px"></i></div>
               <div :hidden="memoFlag">
                <gj-textarea
                    @blur="memoBlur"
                    :styles="{height: '32px', width: '300px'}"
                    v-model="data.memo"
                >
                </gj-textarea>
              </div>
              </div>
            </span>
          </el-col>
          <el-col :span="8" v-if="refundDate">
            <span class="detail-label">首次退款时间</span>
            <span class="detail-value">{{refundDate}}</span>
          </el-col>
        </el-row>

        <div class="mb-top20" v-if="replacementOrder">
          <gj-area-title>换货信息</gj-area-title>
        </div>
        <el-row class="gj-mb10" v-if="replacementOrder">
          <el-col :span="8">
            <span class="detail-label">原订单号</span>
            <span
                class="detail-value">{{ data.replacementOrderVO ? data.replacementOrderVO.originalOrderId : '-' }}</span>
          </el-col>
          <el-col :span="8">
            <span class="detail-label">原发货时间</span>
            <span
                class="detail-value">{{ data.replacementOrderVO ? data.replacementOrderVO.shipmentMarketDate : '-' }}</span>
          </el-col>
          <el-col :span="8">
            <span class="detail-label">换货原因</span>
            <span
                class="detail-value">{{ data.replacementOrderVO ? data.replacementOrderVO.replacementReasonDesc : '-' }}</span>
          </el-col>
        </el-row>

        <div class="mb-top20">
          <gj-area-title>配送信息</gj-area-title>
        </div>
        <el-row class="gj-mb10">
          <el-col :span="8">
            <span class="detail-label">配送服务</span>
            <span class="detail-value">Standard</span>
          </el-col>
          <el-col :span="8">
            <span class="detail-label">配送渠道</span>
            <span class="detail-value" v-if="data.fulfillmentChannel==='AFN'">亚马逊配送</span>
            <span class="detail-value" v-if="data.fulfillmentChannel==='MFN'">卖家自配送</span>
          </el-col>
        </el-row>

        <el-row class="gj-mb10">
          <el-col :span="16">
            <span class="detail-label" style="width: 9%">配送地址</span>
            <span class="detail-value">{{ data.distributionAddress || "亚马逊政策要求，暂停显示"}}</span>
          </el-col>
        </el-row>

        <div class="detail-title mb-top20">
          <gj-area-title>订单详情</gj-area-title>
        </div>
        <gj-table
          :data="data.items"
          :columns="columns"
          :show-overflow="false"
          :adapt-height="false"
          :index="false"
          :isMinHeight="true"
          class="detail-table-remove-hover"
        >
          <template v-slot:picture="{ row }">
            <div style="text-align: center; padding-right: 8px">
              <gj-image size="80" :src="row.imageUrl"></gj-image>
            </div>
          </template>
          <template v-slot:listingInfo="{row}">
            <div style="line-height: 1.5">
              <gj-tooltip :text-line="2" class="item" :content="row.title" placement="top">
                <div class="text-ellipsis-2">{{row.title}}</div>
              </gj-tooltip>
              <div>
                <a :href="row.asinUrl" target="_blank"
                   style="cursor: pointer; color: #1F6EEF; text-decoration-line: none;">{{row.asin}}</a>
                <span v-if="row.asin" v-copy="row.asin"
                      class="copy-icon gj-cell-display-switch">
                  <gj-icon class="el-icon-copy-document"></gj-icon>
                </span>
              </div>
              <el-row>
                {{row.msku}}
                <span v-if="row.msku" v-copy="row.msku"
                      class="copy-icon gj-cell-display-switch">
                    <gj-icon class="el-icon-copy-document"></gj-icon>
                  </span>
              </el-row>
            </div>
          </template>

          <template v-slot:quantity="{ row }">
            {{row.quantityOrdered}}
          </template>
          <template v-slot:shipping="{ row }">
            {{row.quantityShipped}}
          </template>
          <template v-slot:price="{ row }">{{initAmount(row.salePrice)}}</template>
          <template v-slot:promoteFee="{row}">
            <div>
              {{row.testPrincipalCurrencySymbol}}{{row.testPrincipal || '-'}}
            </div>
            <div>{{row.testCommissionCurrencySymbol}}{{row.testCommission || '-'}}
              <gj-popover
                  v-if="$permission('order:markTest')"
                  v-model="row.visible"
              >
                <template slot="reference">
                  <i v-if="$permission('order:markTest')"
                      @click="clickPromoteFee(row)" class="el-icon-edit gj-cell-display-switch"
                     style="margin-left: 6px; cursor: pointer"></i>
                </template>
                <template #default>
                  <el-row style="width: 350px; margin-bottom: 8px;">
                    <el-col :span="12">推广本金</el-col>
                    <el-col :span="12">推广佣金</el-col>
                  </el-row>
                  <el-row class="gj-mb10">
                    <el-col :span="12">
                      <gj-select-input
                          :value="promoteFeePrincipal"
                          :width="['80px', '80px']"
                          :placeholder="['币种', '请输入']"
                          :search="false"
                          :options="currencyOption"
                      >
                      </gj-select-input>
                    </el-col>
                    <el-col :span="12">
                      <gj-select-input
                          :value="promoteFeeCommission"
                          :width="['80px', '80px']"
                          :placeholder="['币种', '请输入']"
                          :search="false"
                          :options="currencyOption">
                      </gj-select-input>
                    </el-col>
                  </el-row>
                  <div style="margin-bottom: 8px;">
                    备注
                  </div>
                  <div>
                    <gj-textarea :styles="{height: '70px'}" v-model="promoteMemo"></gj-textarea>
                  </div>
                  <div style="text-align: right; margin-top: 16px;">
                    <gj-button size="mini" @click.stop="promoteFeeCancel(row)">取消</gj-button>
                    <gj-button size="mini" type="primary" @click.stop="promoteFeeEdit(row)" :loading="loading">确定
                    </gj-button>
                  </div>
                </template>
              </gj-popover>
            </div>
          </template>
          <template v-slot:salesRevenue="{ row }">
            <div class="inner-row">
              <div class="flex justify-between">
                <div class="detail-table-label" style="width: 48px;flex: none;">商品售价</div>
                <div class="detail-value"  style="text-align: right">
                  {{ initAmount(row.itemPrice) }}
                  <span v-if="row.taxPrice">(含税：{{ row.taxPrice }})</span>
                </div>
              </div>
              <div class="flex justify-between detail-table-background">
                <div class="detail-table-label" style="width: 48px;flex: none;">运费</div>
                <div class="detail-value"  style="text-align: right">
                  {{ initAmount(row.shippingPrice) }}
                  <span v-if="row.shippingTaxPrice">(含税：{{ row.shippingTaxPrice }})</span></div>
                </div>
              <el-row>
                <el-col class="detail-table-label" :span="8">促销折扣</el-col>
                <el-col class="detail-value" :span="16" style="text-align: right">
                  {{initAmount(row.promotionDiscount)}}
                </el-col>
              </el-row>
              <el-row class="detail-table-background">
                <el-col class="detail-table-label" :span="8">平台费</el-col>
                <el-col class="detail-value" :span="16" style="text-align: right">{{initAmount(row.platformPrice)}}
                </el-col>
              </el-row>
              <el-row class="detail-table-label" v-if="$permission('cost:view')">
                <el-col style="height: 18px;" :span="18"></el-col>
              </el-row>
              <el-row class="detail-subtotal">
                <el-col :span="12">小计</el-col>
                <el-col :span="12" style="text-align: right;margin-top: 0;">{{initAmount(row.incomeTotal)}}</el-col>
              </el-row>
            </div>
          </template>
          <template v-slot:expenditure="{ row }">
            <div class="inner-row">
              <el-row v-if="$permission('cost:view')">
                <el-col class="detail-table-label" :span="12">成本</el-col>
                <el-col class="detail-value" :span="12" style="text-align: right">{{initAmount(row.cost)}}</el-col>
              </el-row>
              <el-row :class="{'detail-table-background':$permission('cost:view'),'detail-table-label':!$permission('cost:view')}">
                <el-col class="detail-table-label" :span="12">FBA配送费</el-col>
                <el-col class="detail-value" :span="12" style="text-align: right">{{initAmount(row.fbaShipping)}}
                </el-col>
              </el-row>
              <el-row>
                <el-col :class="{'detail-table-label':$permission('cost:view'),'detail-table-background':!$permission('cost:view')}" :span="12">销售佣金</el-col>
                <el-col class="detail-value" :span="12" style="text-align: right">{{initAmount(row.commission)}}
                </el-col>
              </el-row>
              <el-row :class="{'detail-table-background':$permission('cost:view'),'detail-table-label':!$permission('cost:view')}">
                <el-col class="detail-table-label" :span="12">VAT</el-col>
                <el-col class="detail-value" :span="12" style="text-align: right">{{initAmount(row.vatPrice)}}
                </el-col>
              </el-row>
              <el-row :class="{'detail-table-label':$permission('cost:view'),'detail-table-background':!$permission('cost:view')}">
                <el-col class="detail-table-label" :span="12">其他</el-col>
                <el-col class="detail-value" :span="12" style="text-align: right">{{initAmount(row.otherPrice)}}
                </el-col>
              </el-row>
              <el-row class="detail-subtotal">
                <el-col :span="12">小计</el-col>
                <el-col :span="12" style="text-align: right;margin-top: 0;">{{initAmount(row.expenseTotal)}}</el-col>
              </el-row>
            </div>
          </template>
          <template v-slot:profit="{ row }">
            <div class="inner-row">
              <el-row v-if="$permission('cost:view')">
                <el-col class="detail-table-label" :span="12">销售毛利</el-col>
                <el-col :span="12" style="text-align: right">{{initAmount(row.grossProfit)}}</el-col>
              </el-row>
              <el-row class="detail-table-background">
                <el-col class="detail-table-label" :span="12">
                  退款
                  <gj-tooltip>
                    <template #content>
                      <div>数据来源：亚马逊订单费用明细；</div>
                      <div>使用说明：系统退款金额是以卖家视角进行买家、卖家与平台三方数据计算，可直接与日期范围报告中此订单退款金额核对；</div>
                    </template>
                    <i class="iconfont iconbangzhu fontsize12"></i>
                  </gj-tooltip>
                </el-col>
                <el-col class="detail-value" :span="12" style="text-align: right">{{initAmount(row.refundedPrice)}}
                </el-col>
              </el-row>
              <template v-if="row.refundDate">
                <el-row class="detail-table-label">
                  <el-col class="detail-table-label" :span="6">退款时间</el-col>
                  <el-col class="detail-value" :span="18" style="text-align: right">{{row.refundDate | defaultShow}}
                  </el-col>
                </el-row>
              </template>
              <template v-else>
                <el-row class="detail-table-label">
                  <el-col style="height: 18px;" :span="12"></el-col>
                </el-row>
              </template>
              <el-row class="detail-table-label">
                <el-col style="height: 18px;" :span="12"></el-col>
              </el-row>
              <el-row class="detail-table-label" v-if="$permission('cost:view')">
                <el-col style="height: 18px;" :span="12"></el-col>
              </el-row>
              <el-row class="detail-subtotal">
                <el-col :span="12">小计
                  <gj-tooltip content="使用说明：根据订单退款与退货情况进行分别计算，退款不退货/退款退货商品不可售，商品成本将计入小计中一同计算；退款退货商品可售，小计中不计入商品成本；">
                    <i class="iconfont iconbangzhu fontsize12"></i>
                  </gj-tooltip>
                </el-col>
                <el-col :span="12" style="text-align: right;margin-top: 0;">{{initAmount(row.profitTotal)}}</el-col>
              </el-row>
            </div>
          </template>
        </gj-table>

        <!-- 发货信息 -->
        <app-sale-order-shipping-info
          :orderId="orderId"
          :marketId="marketId"
        >
        </app-sale-order-shipping-info>

        <!-- 买家关联订单 -->
        <template v-if="data.orderId">
          <app-sale-order-relation-order
            :buyerEmailKey="data.buyerEmail"
            :orderId="orderId">
          </app-sale-order-relation-order>
        </template>
      </div>
    </template>
    <template #footer>
      <gj-button @click.stop="cancel">关闭</gj-button>
      <template v-if="showBtn">
        <gj-button v-if="$permission('order:refund')" @click.stop="refund">退款</gj-button>
        <gj-button v-if="$permission('order:contactBuyer')" @click.stop="contactBuyer">联系买家</gj-button>
        <gj-button v-if="$permission('order:requestReview') && data.requestReviewStatus !== 'Success'" @click.stop="requestReview" type="primary">请求评论</gj-button>
      </template>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, responseMixin} from "../../../../../minxins";
  import {isMeaningful, isNotBlank} from "../../../../../utils/common";
  import AppSaleOrderShippingInfo from './components/sale-order-shipping-info'
  import AppSaleOrderRelationOrder from './components/sale-order-relation-order'
  import SaleOrderRefund from './sale-order-refund';
  import SaleOrderContactBuyer from './sale-order-contact-buyer';
  import {
    batchRequestReview, contactBuyer,
    getSaleOrderDetail,
    refund,
    updateOrderMemo,
    updatePromoteFee
  } from "../../../../../api/sale";
  import {currencysOption, saleOrderStatus} from "../../../../../utils/options";
  import {mapGetters} from "vuex";
  import { tagColors } from "@/components/tag/tag-colors";

  export default {
    mixins: [modalMixIn, responseMixin],
    name: "sale-order-detail",
    components: { AppSaleOrderShippingInfo, AppSaleOrderRelationOrder },
    computed: {
      ...mapGetters({
        marketMap: 'marketMap',
      })
    },
    props: {
      refundDate: {
        type: String,
      },
      replacementOrder:{
        type:Boolean,
        default: false
      },
      marketId: {
        required: true,
      },
      orderId: {
        required: true,
        type: String,
      },
      showBtn: {
        type: Boolean,
        default: false,
      },
    },
    created() {
      this.loadOrderDetail();
    },
    data() {
      return {
        data: {},
        columns: [
          {id: 'picture', header: '图片', field: 'slot:picture', minWidth: '100px', maxWidth: '100px', default: true},
          {id: 'listingInfo', header: '商品信息', field: 'slot:listingInfo', minWidth: '230px', default: true},
          {id: 'quantity', header: '数量', field: 'slot:quantity', minWidth: '50px', default: true},
          {id: 'shipping', header: '已发货', field: 'slot:shipping', minWidth: '60px', default: true},
          {id: 'price', header: '单价', field: 'slot:price', minWidth: '80px', default: true},
          {id: 'promoteFee', header: '推广费用', field: 'slot:promoteFee', minWidth: '100px', default: true},
          {id: 'salesRevenue', header: '销售收益', field: 'slot:salesRevenue', minWidth: '230px', default: true},
          {id: 'expenditure', header: '支出', field: 'slot:expenditure', minWidth: '160px', default: true},
          {id: 'profit', header: '利润', field: 'slot:profit', minWidth: '230px', default: true},
        ],
        saleOrderStatus: saleOrderStatus,
        currencyOption: currencysOption.map(v => ({id: v.id, text: v.id})),
        memoFlag: true,
        itemId: null,
        promoteFeePrincipal: {},
        promoteFeeCommission: {},
        promoteMemo: '',
        loading: false,
        reloadLoading: false,
        tagColors
      }
    },
    methods: {
      getColor(status){
        switch (status){
          case 'Pending':
            return this.tagColors.orange
          case 'Completed':
            return this.tagColors.green
          case 'Cancelled':
            return this.tagColors.lightGray
        }
      },
      loadOrderDetail() {
        this.reloadLoading = true;
        getSaleOrderDetail(this.marketId, this.orderId)
          .then((data) => {
            this.data = data;
            this.data.marketName = this.marketMap[data.marketId].text;
          }).complete(() => this.reloadLoading = false)
      },
      memoBlur() {
        updateOrderMemo(this.data.id, {id: this.data.id, memo: this.data.memo})
          .then(() => {
            // this.$message.success('保存成功');
          });
        this.memoFlag = true;
      },
      clickPromoteFee(row) {
        this.promoteFeePrincipal = {key: row.testPrincipalCurrency, value: row.testPrincipal};
        this.promoteFeeCommission = {key: row.testCommissionCurrency, value: row.testCommission};
        this.promoteMemo = row.testMemo;
        this.itemId = row.id;
      },
      promoteFeeEdit(row) {
        if ((this.promoteFeePrincipal.key && !this.promoteFeePrincipal.value)
          || (!this.promoteFeePrincipal.key && this.promoteFeePrincipal.value)
          || (!this.promoteFeeCommission.key && this.promoteFeeCommission.value)
          || (this.promoteFeeCommission.key && !this.promoteFeeCommission.value)) {
          this.$gjMessage.error('录入费用时币种与金额必须同时存在');
          return;
        }

        this.loading = true;
        updatePromoteFee({
          fid: this.itemId,
          commission: this.promoteFeeCommission.value,
          commissionCurrency: this.promoteFeeCommission.key,
          principal: this.promoteFeePrincipal.value,
          principalCurrency: this.promoteFeePrincipal.key,
          memo: this.promoteMemo,
        }).then((res) => {
          this.$gjResponseHandle(res, () => {
            this.$gjMessage.success('操作成功');
            this.promoteFeePrincipal = {};
            this.promoteFeeCommission = {};
            this.loadOrderDetail();
            this.$set(row, 'visible', false);
          })
        }).complete(() => this.loading = false);
      },
      promoteFeeCancel(row) {
        this.promoteFeePrincipal = {};
        this.promoteFeeCommission = {};
        this.promoteMemo = '';
        this.$set(row, 'visible', false);
      },
      isNotBlank(memo) {
        return isNotBlank(memo)
      },
      requestReview() {
        const vm = this;
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            content: `是否确定请求评论？`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm() {
              modal.confirmLoading = true;
              batchRequestReview([vm.data.id])
                .complete(() => modal.confirmLoading = false)
                .then(() => {
                  vm.$gjMessage.success('操作成功');
                  modal.$gjDestroy();
                  this.loadOrderDetail();
                })
            }
          },
        });
      },
      refund() {
        const vm = this;
        const modal = this.$gjCreate(SaleOrderRefund, {
          props: {
            id: vm.data.id,
          },
          on: {
            refund(data) {
              modal.loading = true;
              refund({
                id: vm.data.id,
                marketId: vm.marketId,
                refundItemVos: data
              }).then(() => {
                vm.$gjMessage.success('操作成功');
                modal.$gjDestroy();
              }).complete(() => modal.loading = false)
            }
          }
        })
      },
      contactBuyer() {
        const vm = this;
        const modal = this.$gjCreate(SaleOrderContactBuyer, {
          props: {
            id: vm.data.id,
          },
          on: {
            contactBuyer(data) {
              modal.loading = true;
              contactBuyer({...data, marketId: vm.data.marketId, id: vm.data.id})
                .then(() => {
                  vm.$gjMessage.success('操作成功');
                  modal.$gjDestroy();
                }).complete(() => modal.loading = false)
            }
          }
        })
      },
      initAmount(amount) {
        if (isMeaningful(amount)) {
          return this.data.currencySymbol + amount;
        } else {
          return '0.00';
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .mb-top20 {
    margin-top: 20px;
  }

  .detail-title {
    margin-bottom: 12px;
  }

  .detail-label {
    margin-right: 12px;
    display: inline-block;
    width: 18%;
    text-align: right;
    color: #666;
  }

  .detail-value {
    margin-top: 0!important;
    color: #333;
  }

  .detail-table-label {
    color: #666;
  }

  .detail-memo-color {
    color: #bbb;
    font-size: 12px;
  }

  .detail-table-background {
    background: #f5f7fa;
  }

  .detail-subtotal {
    font-weight: 700;
    color: #333;
  }

  .detail-table-remove-hover {
  }

  .detail-table-remove-hover /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
    background: white;
  }


  /deep/ tr:hover > td {
    background: #fff;
  }
  /deep/ .el-dialog__body{
    padding-bottom: 0;
  }
</style>
